import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { CoreService } from "src/app/shared/services/core.service";
import { BrandProductSettingsResolver } from "./brand-product-settings.resolver";
import { GlobalSettingsResolver } from "./global-settings.resolver";
import { IdleSetupResolver } from "./idle-setup.resolver";
import { NewSessionResolver } from "./new-session.resolver";
import { ProductResolver } from "./product.resolver";

@Injectable({
  providedIn: "root"
})
export class ProductInitResolver implements Resolve<boolean> {
  constructor(
    protected globalSettingsResolver: GlobalSettingsResolver,
    protected idleSetupResolver: IdleSetupResolver,
    protected newSessionResolver: NewSessionResolver,
    protected productResolver: ProductResolver,
    protected coreService : CoreService,
    protected brandProductSettingsResolver: BrandProductSettingsResolver
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(async (res, rej) => {
      await Promise.all([
        this.newSessionResolver.resolve(route, state),
        this.globalSettingsResolver.resolve(route, state)
      ]);

      await Promise.all([
        this.idleSetupResolver.resolve(route, state),
        this.productResolver.resolve(route, state)
      ])

      await this.brandProductSettingsResolver.resolve(route, state);

     this.coreService.isDataLoaded.next(true);

      res(true);
    });
  }
}
